var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appointments-empty"},[(_vm.hasTitle)?_c('div',{staticClass:"appointments-empty__title"},[_vm._t("title")],2):_vm._e(),(_vm.hasText)?_c('div',{staticClass:"appointments-empty__text"},[_vm._t("text")],2):_vm._e(),(_vm.hasFooter)?_c('div',{staticClass:"appointments-empty__footer"},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }